import { ArrowRight } from "lucide-react";

import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { Reveal } from "@/components/ui/Reveal";

interface CTABandProps {
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonTo?: string;
}

export function CTABand({
  title = "Ready to make your site audit-ready?",
  description = "Talk to our team about how MedCore Research can support your next study — from start-up to close-out.",
  buttonLabel = "Contact Us",
  buttonTo = "/contact",
}: CTABandProps) {
  return (
    <section data-testid="contact-cta-band">
      <Container className="py-16 lg:py-20">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl border border-border bg-muted px-6 py-12 text-center sm:px-12 lg:py-16 section-accent">
            <h2 className="mx-auto max-w-2xl text-2xl font-semibold tracking-tight text-foreground sm:text-3xl text-balance">
              {title}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted-foreground">
              {description}
            </p>
            <div className="mt-8 flex justify-center">
              <Button as="link" to={buttonTo} size="lg" data-testid="contact-cta-button">
                {buttonLabel}
                <ArrowRight size={18} />
              </Button>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
